
const CkycDetailsCard = ({ details }) => {
    if (!details) return null;

    const pd = details.personal_details || {};
    const idDetails = details.identity_details?.identity || [];
    const imageDetails = details.image_details?.image || [];

    const getIdentity = (type) => idDetails.find(id => id.ident_type === type)?.ident_num || '-';

    const photograph = imageDetails.find(img => img.image_code === "Photograph")?.image_url;

    return (
        <div className="card mt-4">
            <div className="card-body">
                <div className="row g-2 ckyc_details_container">
                    {/* Personal Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Personal Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">Full Name</span><span className="w-50 text-break">{pd.full_name || '-'}</span></li>
                                        <li><span className="label w-50">Father's Name</span><span className="w-50 text-break">{pd.father_fullname || '-'}</span></li>
                                        <li><span className="label w-50">Mother's Name</span><span className="w-50 text-break">{pd.mother_fullname || '-'}</span></li>
                                        <li><span className="label w-50">Date of Birth</span><span className="w-50 text-break">{pd.dob || '-'}</span></li>
                                        <li><span className="label w-50">Age</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Gender</span><span className="w-50 text-break">{pd.gender === 'M' ? 'Male' : pd.gender === 'F' ? 'Female' : pd.gender || '-'}</span></li>
                                        <li><span className="label w-50">Marital Status</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Nationality</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Occupation</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Identity Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Identity Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">PAN</span><span className="w-50 text-break">{pd.pan || '-'}</span></li>
                                        <li><span className="label w-50">Aadhaar Number</span><span className="w-50 text-break">{getIdentity("Proof Of Aadhaar") || '-'}</span></li>
                                        <li><span className="label w-50">CKYC ID</span><span className="w-50 text-break">{pd.ckyc_no || '-'}</span></li>
                                        <li><span className="label w-50">CKYC Reference ID</span><span className="w-50 text-break">{pd.ckyc_reference_id || '-'}</span></li>
                                        <li><span className="label w-50">Other ID Type</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Other ID Number</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Issuing Authority</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Contact Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Contact Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">Mobile Number</span><span className="w-50 text-break">{pd.mob_code ? `+${pd.mob_code} ${pd.mob_num}` : pd.mob_num || '-'}</span></li>
                                        <li><span className="label w-50">Alternate Mobile Number</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Email ID</span><span className="w-50 text-break">{pd.email || '-'}</span></li>
                                        <li><span className="label w-50">Telephone Number</span><span className="w-50 text-break">{pd.resi_std_code ? `${pd.resi_std_code}-${pd.resi_tel_num}` : '-'}</span></li>
                                        <li><span className="label w-50">Preferred Communication</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Address Type</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Photo */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card position-relative h-100 mb-0 d-flex flex-column align-items-center justify-content-center pt-5">
                            <div className="card-header border-0 pb-0 w-100 text-start position-absolute top-0 start-0">
                                <h4 className="title">Photo</h4>
                            </div>
                            <div className="card-body d-flex flex-column align-items-center w-100 mt-3">
                                {photograph ? (
                                    <img src={photograph} alt="CKYC" className="img-fluid rounded mb-3" style={{ maxHeight: '180px', objectFit: 'contain' }} />
                                ) : (
                                    <div className="bg-light rounded mb-3 d-flex align-items-center justify-content-center" style={{ width: '150px', height: '180px' }}>
                                        <i className="fa fa-user fs-1 text-secondary"></i>
                                    </div>
                                )}
                                <span className="text-muted fs-6">Photo available in CKYC</span>
                            </div>
                        </div>
                    </div>

                    {/* Address Details */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Address Details</h4>
                            </div>
                            <div className="card-body">
                                <h5 className="text-primary fw-bold mb-3">Current Address</h5>
                                <div className="content_box_container mb-4">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">House / Flat / Building</span><span className="w-50 text-break">{pd.corres_line1 || '-'}</span></li>
                                        <li><span className="label w-50">Street / Area</span><span className="w-50 text-break">{pd.corres_line2 || '-'}</span></li>
                                        <li><span className="label w-50">Landmark</span><span className="w-50 text-break">{pd.corres_line3 || '-'}</span></li>
                                        <li><span className="label w-50">City</span><span className="w-50 text-break">{pd.corres_city || '-'}</span></li>
                                        <li><span className="label w-50">State</span><span className="w-50 text-break">{pd.corres_state || '-'}</span></li>
                                        <li><span className="label w-50">Country</span><span className="w-50 text-break">{pd.corres_country || '-'}</span></li>
                                        <li><span className="label w-50">PIN Code</span><span className="w-50 text-break">{pd.corres_pin || '-'}</span></li>
                                    </ul>
                                </div>

                                <h5 className="text-primary fw-bold mb-3">Permanent Address</h5>
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">House / Flat / Building</span><span className="w-50 text-break">{pd.perm_line1 || '-'}</span></li>
                                        <li><span className="label w-50">Street / Area</span><span className="w-50 text-break">{pd.perm_line2 || '-'}</span></li>
                                        <li><span className="label w-50">Landmark</span><span className="w-50 text-break">{pd.perm_line3 || '-'}</span></li>
                                        <li><span className="label w-50">City</span><span className="w-50 text-break">{pd.perm_city || '-'}</span></li>
                                        <li><span className="label w-50">State</span><span className="w-50 text-break">{pd.perm_state || '-'}</span></li>
                                        <li><span className="label w-50">Country</span><span className="w-50 text-break">{pd.perm_country || '-'}</span></li>
                                        <li><span className="label w-50">PIN Code</span><span className="w-50 text-break">{pd.perm_pin || '-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* CKYC Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">CKYC Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li>
                                            <span className="label w-50">CKYC Status</span>
                                            <span className="w-50"><span className="badge bg-success bg-opacity-10 text-success border border-success">Active</span></span>
                                        </li>
                                        <li><span className="label w-50">Registration Date</span><span className="w-50 text-break">{pd.dec_date || '-'}</span></li>
                                        <li><span className="label w-50">Last Updated Date</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">CKYC Version</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">KYC Type</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">Reporting Entity</span><span className="w-50 text-break">Central KYC Records Registry</span></li>
                                        <li><span className="label w-50">Fetched On</span><span className="w-50 text-break">{'-'}</span></li>
                                        <li><span className="label w-50">KYC Mode</span><span className="w-50 text-break">{'-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Document Details */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Document Details</h4>
                            </div>
                            <div className="card-body px-1">
                                <div className="table-responsive">
                                    <table className="table table-borderless table-sm mb-0">
                                        <thead>
                                            <tr className="border-bottom">
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Document Type</th>
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Document Number</th>
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Issue Date</th>
                                                <th className="text-muted fw-normal pb-2 px-2" style={{ fontSize: '13px' }}>Expiry Date</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {idDetails.map((doc, index) => (
                                                <tr key={index}>
                                                    <td className="fw-medium px-2" style={{ fontSize: '14px' }}>{doc.ident_type}</td>
                                                    <td className="fw-medium px-2" style={{ fontSize: '14px' }}>{doc.ident_num}</td>
                                                    <td className="fw-medium px-2 text-muted" style={{ fontSize: '14px' }}>{'-'}</td>
                                                    <td className="fw-medium px-2 text-muted" style={{ fontSize: '14px' }}>{'-'}</td>
                                                </tr>
                                            ))}
                                            {idDetails.length === 0 && (
                                                <tr>
                                                    <td colSpan="4" className="text-center text-muted pt-3">No documents found</td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Other Information */}
                    <div className="col-12 col-xl-3 col-lg-6 mb-2">
                        <div className="profile_card h-100 mb-0">
                            <div className="card-header border-0 pb-0">
                                <h4 className="title">Other Information</h4>
                            </div>
                            <div className="card-body">
                                <div className="content_box_container">
                                    <ul className="content_box list-unstyled">
                                        <li><span className="label w-50">Source</span><span className="w-50 text-break">Central KYC Records Registry</span></li>
                                        <li><span className="label w-50">Remarks</span><span className="w-50 text-break">{pd.remarks || '-'}</span></li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CkycDetailsCard;
